module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('a', {
    ref: "mailLink",
    attrs: {
      "hidden": "",
      "target": "_blank",
      "href": "mailto:jsangio1@gmail.com?"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.isOpen),
      callback: function($$v) {
        _vm.isOpen = $$v
      },
      expression: "isOpen"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Contact Form")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "autofocus": "",
      "label": "Name",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.contactInfo.name),
      callback: function($$v) {
        _vm.$set(_vm.contactInfo, "name", $$v)
      },
      expression: "contactInfo.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "E-mail",
      "rules": [_vm.rules.email]
    },
    model: {
      value: (_vm.contactInfo.email),
      callback: function($$v) {
        _vm.$set(_vm.contactInfo, "email", $$v)
      },
      expression: "contactInfo.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "phone",
      "type": "number",
      "label": "Phone Number"
    },
    model: {
      value: (_vm.contactInfo.phone),
      callback: function($$v) {
        _vm.$set(_vm.contactInfo, "phone", $$v)
      },
      expression: "contactInfo.phone"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": this.contactReasons,
      "label": "Reason for Contact",
      "autocomplete": "",
      "multiple": "",
      "bottom": ""
    },
    model: {
      value: (_vm.contactInfo.contactReasons),
      callback: function($$v) {
        _vm.$set(_vm.contactInfo, "contactReasons", $$v)
      },
      expression: "contactInfo.contactReasons"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Subject",
      "required": "",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.contactInfo.subject),
      callback: function($$v) {
        _vm.$set(_vm.contactInfo, "subject", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "contactInfo.subject"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Body [leave blank for templated]"
    },
    model: {
      value: (_vm.contactInfo.body),
      callback: function($$v) {
        _vm.$set(_vm.contactInfo, "body", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "contactInfo.body"
    }
  }), _vm._v(" "), _c('small', [_vm._v("*indicates required field")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        (function () { return _vm.emitEvent('toggleForm'); })($event)
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "disabled": (!_vm.isFormValid()),
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sendForm()
      }
    }
  }, [_vm._v("Send (In a New Tab)\n                ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a9bf0f7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactForm.vue
// module id = 456
// module chunks = 0